import {
  animate,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { SettingsService } from '../../core/http/settings.service';
import { DropDownComponent } from '../../shared/components/drop-down/drop-down.component';
import { UserComponent } from '../../shared/components/user/user.component';
import { ModalService } from '../../shared/services/modal.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  animations: [
    trigger('mobileNav', [
      state(
        'grow',
        style({
          height: '*',
        })
      ),
      state(
        'shrink',
        style({
          height: 0,
        })
      ),
      transition('shrink => grow', [
        animate('400ms cubic-bezier(0.35, 0, 0.25, 1)'),
      ]),
      transition('grow => shrink', [
        animate('200ms cubic-bezier(0.0, 0.0, 0.2, 1)'),
      ]),
    ]),
  ],
})
export class NavBarComponent implements OnInit {

  token: string;
  isLoading = true;
  Errors = null;
  data = null;
  run = false;
  name;
  username: string ;
  role = localStorage.getItem('role');
  toggle = false

  getToken() {
    this.token = localStorage.getItem('token');
    this.username = localStorage.getItem('username');
  }
  togle() {
    this.toggle = !this.toggle
    console.log("tog");

  }

  constructor(public router: Router, private modal: ModalService, private _snackBar: MatSnackBar, public setting: SettingsService, public auth: AuthServiceService) { }

  logout() {

    if (this.role  == 'self-service user' || this.role == 'self-service consultant') {
      console.log("online");

      this.setting.logouonline()
    .subscribe(
      (resSuccess) => {

        this.data = resSuccess
        this.isLoading = false;

        if (this.data.success) {
          this.router.navigate(['/login'])
          localStorage.removeItem('token');
          localStorage.removeItem('id');
          localStorage.removeItem('name');
          localStorage.clear();
          this._snackBar.open(this.data.message, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
        else {
          this.isLoading = false;
          console.log(resSuccess)
          this._snackBar.open("Error try again", '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }

      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr)
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
    }else {
      console.log("offline");

      this.setting.logout()
    .subscribe(
      (resSuccess) => {

        this.data = resSuccess
        this.isLoading = false;

        if (this.data.success) {
          this.router.navigate(['/login'])
          localStorage.removeItem('token');
          localStorage.removeItem('id');
          localStorage.removeItem('name');
          this._snackBar.open(this.data.message, '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
        else {
          this.isLoading = false;
          console.log(resSuccess)
          this._snackBar.open("Error try again", '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }

      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
        console.log(resErr)
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
      }
    );
    }
    this.getToken()
    console.log(this.role)

    this.name = localStorage.getItem("name")
  }

  ngOnInit(): void {
    if (this.role  == 'self-service user' || this.role == 'self-service consultant') {
      console.log("online");

      this.setting
      .getTitleonline()
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess
          switch(this.data.message) {
            case "Session Expired":
              this.data.message = "false"
              // window.location.href = "/login";
              this.router.navigate(['/login'])
              break;
            case "false":

              break;
            default:
              // code block
          }
          // this.data = resSuccess
          // if ( this.data.message = "Session Expired") {
          //   if (this.run = false){
          //     window.location.href = "/login";
          //     this.run = true
          //   }
          // }


        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    }else {
      console.log("offline");

      this.setting
      .getTitle()
      .subscribe(
        (resSuccess) => {
          this.data = resSuccess
          switch(this.data.message) {
            case "Session Expired":
              this.data.message = "false"
              // window.location.href = "/login";
              this.router.navigate(['/login'])
              break;
            case "false":

              break;
            default:
              // code block
          }
          // this.data = resSuccess
          // if ( this.data.message = "Session Expired") {
          //   if (this.run = false){
          //     window.location.href = "/login";
          //     this.run = true
          //   }
          // }


        },
        (resErr) => {
          this.Errors = resErr;
        }
      );
    }
    this.getToken()
    console.log(this.role)

    this.name = localStorage.getItem("name")

  }

  openUser() {
    this.modal.openModal(UserComponent, 'modal');
  }

  opendrop() {
    this.modal.openModal(DropDownComponent, 'modal');
  }

}
